import { render, staticRenderFns } from "./LogoHorizontal.vue?vue&type=template&id=31200fda"
import script from "./LogoHorizontal.vue?vue&type=script&lang=js"
export * from "./LogoHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31200fda')) {
      api.createRecord('31200fda', component.options)
    } else {
      api.reload('31200fda', component.options)
    }
    module.hot.accept("./LogoHorizontal.vue?vue&type=template&id=31200fda", function () {
      api.rerender('31200fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/LogoHorizontal.vue"
export default component.exports